module.exports = __webpack_public_path__ + "static/img/IMG_20170525_123817.79a2f1ec.jpg";